export default "__VITE_PUBLIC_ASSET__37ff84da__"